import { jsxs, jsx } from 'react/jsx-runtime';
import { themedColor, disabledInteraction } from '@lemonade-hq/cdk';
import { randomString, ABC } from '@lemonade-hq/ts-helpers';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  &:before {\n    border-radius: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  &:before {\n    content: '';\n    display: block;\n    position: absolute;\n    top: -6px;\n    bottom: -6px;\n    left: -6px;\n    right: -6px;\n    border: 2px solid ",
        ";\n    opacity: 1;\n    transition: opacity 0.3s ease;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n      width: 25px;\n      height: 24px;\n      border-radius: 12px;\n      box-shadow: 0 4px 8px -4px ",
        ";\n      top: 2px;\n      left: 2px;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n      left: 21px;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n      width: 50px;\n      height: ",
        "px;\n      border-radius: 15px;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n      width: 34px;\n      height: 34px;\n      border-radius: 30px;\n      box-shadow: 0 2px 5px 1px ",
        ";\n      top: 2px;\n      left: 2px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n      left: 42px;\n      box-shadow: none;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n      width: 80px;\n      height: ",
        "px;\n      border-radius: 30px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  cursor: pointer;\n  text-indent: -9999px;\n  background: ",
        ";\n  display: inline-block;\n  position: relative;\n  border: 1px solid transparent;\n  ",
        "\n\n  &:hover:not([disabled]) {\n    border-color: ",
        ";\n  }\n\n  &:after {\n    content: '';\n    position: absolute;\n    background: ",
        ";\n    transition: 0.2s ease-out;\n    ",
        "\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n        ",
        "\n        ",
        "\n      "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  appearance: none;\n\n  &:checked + ",
        " {\n    background-color: ",
        ";\n\n    &:hover:not([disabled]) {\n      border-color: ",
        ";\n    }\n  }\n\n  &:focus + ",
        ", &:active + ",
        " {\n    ",
        "\n  }\n\n  &:disabled {\n    box-shadow: none;\n    opacity: 0;\n  }\n\n  &:disabled + ",
        " {\n    ",
        ";\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n\n  &:disabled + ",
        ":after {\n    box-shadow: none;\n  }\n\n  &:checked + ",
        ":after {\n    ",
        "\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: inline-block;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
/**
 * A year from now, check if safari automatically adapts `outline` property to the element radius
 * https://team-lemonade.fibery.io/Software_Dev/Task/Replace-button-switch-focus-styles-from-border-to-outline-8129
 */ // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
var focusOutlineBorderRadius = function(borderRadius) {
    return css(_templateObject(), borderRadius);
};
var SWITCH_HEIGHTS = {
    small: 30,
    big: 40
};
var focusOutline = css(_templateObject1(), function(param) {
    var theme = param.theme;
    return rgba(theme.colors.primary, 0.3);
});
var SIZE_STYLES = {
    small: {
        toggle: css(_templateObject2(), function(param) {
            var theme = param.theme;
            return rgba(theme.colors.black, 0.5);
        }),
        toggleOn: css(_templateObject3()),
        switch: css(_templateObject4(), SWITCH_HEIGHTS.small)
    },
    big: {
        toggle: css(_templateObject5(), themedColor("metal")),
        toggleOn: css(_templateObject6()),
        switch: css(_templateObject7(), SWITCH_HEIGHTS.big)
    }
};
var Label = styled.label(_templateObject8(), themedColor("cloud"), function(param) {
    var kind = param.kind;
    return SIZE_STYLES[kind].switch;
}, themedColor("solidGray"), themedColor("white"), function(param) {
    var kind = param.kind;
    return SIZE_STYLES[kind].toggle;
});
var Input = styled.input(_templateObject10(), Label, themedColor("primary"), themedColor("darkPink"), Label, Label, function(param) {
    var isFocusVisible = param.isFocusVisible;
    return isFocusVisible && css(_templateObject9(), focusOutline, focusOutlineBorderRadius(40));
}, Label, disabledInteraction, Label, Label, function(param) {
    var kind = param.kind;
    return SIZE_STYLES[kind].toggleOn;
});
var Wrapper = styled.div(_templateObject11());
var Switch = function(_param) {
    var _param_size = _param.size, size = _param_size === void 0 ? "small" : _param_size, value = _param.value, onChange = _param.onChange, isFocusVisible = _param.isFocusVisible, _param_id = _param.id, id = _param_id === void 0 ? randomString(10, ABC) : _param_id, nativeInputProps = _object_without_properties(_param, [
        "size",
        "value",
        "onChange",
        "isFocusVisible",
        "id"
    ]);
    return /*#__PURE__*/ jsxs(Wrapper, {
        style: {
            height: SWITCH_HEIGHTS[size]
        },
        children: [
            /*#__PURE__*/ jsx(Input, _object_spread({
                "aria-checked": value,
                checked: value,
                id: id,
                isFocusVisible: isFocusVisible,
                kind: size,
                onChange: onChange,
                type: "checkbox"
            }, nativeInputProps)),
            /*#__PURE__*/ jsx(Label, {
                htmlFor: id,
                isFocusVisible: isFocusVisible,
                kind: size,
                children: "Toggle"
            })
        ]
    });
};

export { Switch, focusOutline, focusOutlineBorderRadius };
